var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36173 7.39157H5.31125V14.8126H2.20461V7.39157H0.727081V4.78351H2.20461V3.09579C2.20461 1.8889 2.78493 -0.000976562 5.33891 -0.000976562L7.64011 0.00853453V2.5401H5.97044C5.69656 2.5401 5.31146 2.67528 5.31146 3.25101V4.78593H7.63314L7.36173 7.39157Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;